import { MutationTree } from "vuex";
import { IdomMemStateInterface } from "./state";
import {
  IDataTemplateSettings,
  IGptPhrases,
} from "src/modules/idom-mem/models";

const mutation: MutationTree<IdomMemStateInterface> = {
  setSettings(state, payload: IDataTemplateSettings) {
    state.settings = payload;
  },
  setSettingLocalValue(state, payload: { idx: number; value: string }) {
    if (state.settings) {
      state.settings.template[payload.idx].localValue = payload.value;
    }
  },
  setCount(state, payload: { count: number; key: string }) {
    state.counts[payload.key] = payload.count;
  },
  resetCounts(state) {
    state.counts = {};
  },
  setLoading(state, loading: boolean) {
    state.loading = loading;
  },
  setGptPhrases(state, phrase: IGptPhrases) {
    const index = state.gptPhrases.findIndex((p) => p.text === phrase.text);
    if (index !== -1) {
      state.gptPhrases[index].phrases.push(...phrase.phrases);
      return;
    }
    state.gptPhrases.push(phrase);
  },
  deleteGptPhrase(state, text: string) {
    const index = state.gptPhrases.findIndex((p) => p.text === text);
    if (index !== -1) {
      state.gptPhrases[index].phrases.shift();
    }
  },
  setLoadingGpt(state, loading: boolean) {
    state.loadingGpt = loading;
  },
};

export default mutation;
